export default __webpack_public_path__ + "media/images/45-1fd67cc65214bed26c9a17a488910422.png";